import { useEffect, useRef, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useRoutes } from "hooks/useRoutes";

import authentication from "hooks/authentication.js";
import backgroundImage from "assets/img/background/auth.jpeg";
import brandsImage from "assets/img/logos/group.png";
import { makeStyles, Typography } from "@material-ui/core";

const useCustomStyles = makeStyles({
  header: {
    width: "100vw",
    padding: "2rem",
    textAlign: "center",
  },
  background: {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    height: "100vh",
  },
  footer: {
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    padding: "2rem",
    position: "absolute",
    bottom: 0,
  },
  footerImage: {
    width: "auto",
    height: "10vh",
  },
});

export default function Auth() {
  const classes = useCustomStyles();
  const { routesVision } = useRoutes();
  const mainContent = useRef(null);
  const [userRoutes, setUserRoutes] = useState(routesVision);

  useEffect(() => {
    if (routesVision) {
      setUserRoutes(routesVision);
    }
  }, [routesVision]);

  const getRoutes = (routesUser) => {
    if (authentication.userLoggedIn === true) {
      return <Redirect to="/admin" />;
    }
    return routesUser?.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div ref={mainContent} className={classes.background}>
      <header className={classes.header}>
        <Typography variant="subtitle2" color="textSecondary">
          Bem vindo ao portal do cliente lojista
        </Typography>
      </header>
      <Switch>
        {getRoutes(userRoutes)}
        <Redirect from="*" to="/auth/login" />
      </Switch>
      <footer className={classes.footer}>
        <img src={brandsImage} className={classes.footerImage} />
      </footer>
    </div>
  );
}
